import React, { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { LI, UL } from "../../AbstractElements";
// import { MENUITEMS } from "./Menu";
import {
  AppstoreAddOutlined,
  CheckCircleOutlined,
  FileTextOutlined,
  FolderOutlined,
  GoldOutlined,
  ProjectOutlined,
  SearchOutlined,
  SettingOutlined,
  TagOutlined,
  UserOutlined,
  WalletOutlined
} from "@ant-design/icons";
import { useState } from "react";
import { LogOut } from "react-feather";
import { connect } from "react-redux";
import { Label } from "reactstrap";
import { LogEvents, LoggerContext } from "../../context/logging";
import {
  bidViewGranted,
  fileManagerViewGranted,
  poViewGranted,
  vendorViewGranted,
} from "../../utils/PermissionFunctions/userPermissions";
const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});
const SidebarMenuItems = (props) => {
  // eslint-disable-next-line
  const logger = React.useContext(LoggerContext);

  const location = useLocation();

  console.log("i-log> location", location?.pathname.split("/")[1]);

  const MENUITEMS = [
    {
      menutitle: "Applications",
      Items: [
        {
          title: "Project Dashboard",
          icon: <AppstoreAddOutlined />,
          type: "link",
          active: location?.pathname.split("/")[1] === "project-dashboard",
          path: `/project-dashboard`,
          inner: true,
          outer: false,
        },
        {
          title: "Budget",
          icon: <WalletOutlined />,
          type: "link",
          active: location?.pathname === "/app/project/budget",
          path: `/app/project/budget`,
          inner: true,
          outer: false,
        },
        poViewGranted(props.settings.user)
          ? {
              title: "Po/Wo",
              icon: <FileTextOutlined />,
              type: "link",
              active: location?.pathname === "/app/project/powo",
              path: `/app/project/powo`,
              inner: true,
              outer: false,
            }
          : {},
        bidViewGranted(props.settings.user)
          ? {
              title: "Biddings",
              icon: <TagOutlined />,
              type: "link",
              active: location?.pathname === "/app/project/biddings",
              path: `/app/project/biddings`,
              inner: true,
              outer: false,
            }
          : {},
        {
          title: "Project",
          icon: <ProjectOutlined />,
          type: "link",
          active: location?.pathname === "/app/project/project-list",
          path: `/app/project/project-list`,
          inner: false,
          outer: true,
        },
        vendorViewGranted(props.settings.user)
          ? {
              title: "Vendors",
              icon: <GoldOutlined />,
              type: "link",
              active: location?.pathname === "/app/vendor/vendor-list",
              path: `/app/vendor/vendor-list`,
              inner: true,
              outer: true,
            }
          : {},
        {
          title: "Rate Contracts",
          icon: <TagOutlined />,
          type: "link",
          active: location?.pathname === "/app/project/rate-contracts",
          path: `/app/project/rate-contracts`,
          inner: true,
          outer: true,
        },
        // {
        //   title: "Inventory",
        //   icon: <UnorderedListOutlined />,
        //   type: "link",
        //   active: location?.pathname === "/app/inventory",
        //   path: `/app/inventory`,
        //   inner: true,
        //   outer: true,
        //   children: [
        //     {
        //       title: "Overview",
        //       type: "link",
        //       active: location?.pathname === "/app/inventory",
        //       path: `/app/inventory`,
        //     },
        //     {
        //       title: "Category",
        //       type: "link",
        //       active: location?.pathname === "/app/inventory/category",
        //       path: `/app/inventory/category`,
        //     },
        //     {
        //       title: "Sub Category",
        //       type: "link",
        //       active: location?.pathname === "/app/inventory/sub-category",
        //       path: `/app/inventory/sub-category`,
        //     },
        //     {
        //       title: "Items",
        //       type: "link",
        //       active: location?.pathname === "/app/inventory/items",
        //       path: `/app/inventory/items`,
        //     },
        //     {
        //       title: "Customers",
        //       type: "link",
        //       active: location?.pathname === "/app/project/inventory/customer",
        //       path: `/app/project/inventory/customer`,
        //       inner: true,
        //       outer: false,
        //     },
        //   ],
        // },
        {
          title: "Approvals",
          icon: <CheckCircleOutlined />,
          type: "link",
          active: location?.pathname === "/app/approval/approvals",
          path: `/app/approval/approvals`,
          inner: true,
          outer: true,
        },
        fileManagerViewGranted(props.settings.user)
          ? {
              path: `/app/files`,
              icon: <FolderOutlined />,
              title: "Project Files",
              type: "link",
              inner: true,
              outer: false,
              active: location?.pathname === "/app/files",
            }
          : {},
        // {
        //   title: "Explore",
        //   icon: <SearchOutlined />,
        //   type: "link",
        //   active: location?.pathname === "/app/ecommerce/product",
        //   path: `/app/ecommerce/product`,
        //   inner: true,
        //   outer: false,
        // },
        // {
        //   title: "Organisation",
        //   icon: Settings,
        //   type: "link",
        //   active: false,
        //   path: `/app/organisation`,
        //   inner: true,
        //   outer: true,
        // },
        {
          title: "Settings",
          icon: <SettingOutlined />,
          type: "link",
          active: location?.pathname === "/app/project/project-settings",
          path: `/app/project/project-settings`,
          inner: true,
          outer: false,
        },

        {
          title: "Logout",
          icon: LogOut,
          type: "logout",
          active: false,
          // path: `/app/project/project-settings`,
          inner: false,
          outer: true,
        },
      ],
    },
  ];

  const MENUITEMS_LEADID = [
    {
      menutitle: "Applications",
      Items: [
        {
          title: "Project Dashboard",
          icon: <AppstoreAddOutlined />,
          type: "link",
          active: location?.pathname.split("/")[1] === "project-dashboard",
          path: `/project-dashboard`,
          inner: true,
          outer: false,
        },
        {
          title: "Budget",
          icon: <WalletOutlined />,
          type: "link",
          active: location?.pathname === "/app/project/budget",
          path: `/app/project/budget`,
          inner: true,
          outer: false,
        },
        poViewGranted(props.settings.user)
          ? {
              title: "Po/Wo",
              icon: <FileTextOutlined />,
              type: "link",
              active: location?.pathname === "/app/project/powo",
              path: `/app/project/powo`,
              inner: true,
              outer: false,
            }
          : {},
        bidViewGranted(props.settings.user)
          ? {
              title: "Biddings",
              icon: <TagOutlined />,
              type: "link",
              active: location?.pathname === "/app/project/biddings",
              path: `/app/project/biddings`,
              inner: true,
              outer: false,
            }
          : {},
        {
          title: "Project",
          icon: <ProjectOutlined />,
          type: "link",
          active: location?.pathname === "/app/project/project-list",
          path: `/app/project/project-list`,
          inner: false,
          outer: true,
        },
        vendorViewGranted(props.settings.user)
          ? {
              title: "Vendors",
              icon: <GoldOutlined />,
              type: "link",
              active: location?.pathname === "/app/vendor/vendor-list",
              path: `/app/vendor/vendor-list`,
              inner: true,
              outer: true,
            }
          : {},
        {
          title: "Rate Contracts",
          icon: <TagOutlined />,
          type: "link",
          active: location?.pathname === "/app/project/rate-contracts",
          path: `/app/project/rate-contracts`,
          inner: true,
          outer: true,
        },
        // {
        //   title: "Inventory",
        //   icon: <UnorderedListOutlined />,
        //   type: "link",
        //   active: location?.pathname === "/app/inventory",
        //   path: `/app/inventory`,
        //   inner: true,
        //   outer: true,
        //   children: [
        //     {
        //       title: "Overview",
        //       type: "link",
        //       active: location?.pathname === "/app/inventory",
        //       path: `/app/inventory`,
        //     },
        //     {
        //       title: "Category",
        //       type: "link",
        //       active: location?.pathname === "/app/inventory/category",
        //       path: `/app/inventory/category`,
        //     },
        //     {
        //       title: "Sub Category",
        //       type: "link",
        //       active: location?.pathname === "/app/inventory/sub-category",
        //       path: `/app/inventory/sub-category`,
        //     },
        //     {
        //       title: "Items",
        //       type: "link",
        //       active: location?.pathname === "/app/inventory/items",
        //       path: `/app/inventory/items`,
        //     },
        //     {
        //       title: "Customers",
        //       type: "link",
        //       active: location?.pathname === "/app/project/inventory/customer",
        //       path: `/app/project/inventory/customer`,
        //       inner: true,
        //       outer: false,
        //     },
        //   ],
        // },
        {
          title: "Pro Forma Invoice",
          icon: <TagOutlined />,
          type: "link",
          active: location?.pathname === "/app/project/estimates",
          path: `/app/project/estimates`,
          inner: true,
          outer: false,
        },
        {
          title: "Pro Forma Invoice",
          icon: <TagOutlined />,
          type: "link",
          active: location?.pathname === "/app/estimates",
          path: `/app/estimates`,
          inner: false,
          outer: true,
        },
        props.settings.organisation?.lead_field
          ? {
              title: "Clients",
              icon: <CheckCircleOutlined />,
              type: "link",
              active: window?.location?.pathname == "/app/clients",
              path: `/app/clients`,
              inner: true,
              outer: true,
            }
          : {},
        props.settings.organisation?.lead_field
          ? {
              title: "User Dashboard",
              icon: <UserOutlined />,
              type: "link",
              active: location?.pathname === "/user-dashboard",
              path: `/user-dashboard`,
              inner: false,
              outer: true,
            }
          : {},
        {
          title: "Approvals",
          icon: <CheckCircleOutlined />,
          type: "link",
          active: location?.pathname === "/app/approval/approvals",
          path: `/app/approval/approvals`,
          inner: true,
          outer: true,
        },
        fileManagerViewGranted(props.settings.user)
          ? {
              path: `/app/files`,
              icon: <FolderOutlined />,
              title: "Project Files",
              type: "link",
              inner: true,
              outer: false,
              active: location?.pathname === "/app/files",
            }
          : {},
        {
          title: "Explore",
          icon: <SearchOutlined />,
          type: "link",
          active: location?.pathname === "/app/ecommerce/product",
          path: `/app/ecommerce/product`,
          inner: true,
          outer: false,
        },
        // {
        //   title: "Organisation",
        //   icon: Settings,
        //   type: "link",
        //   active: false,
        //   path: `/app/organisation`,
        //   inner: true,
        //   outer: true,
        // },
        {
          title: "Settings",
          icon: <SettingOutlined />,
          type: "link",
          active: location?.pathname === "/app/project/project-settings",
          path: `/app/project/project-settings`,
          inner: true,
          outer: false,
        },

        {
          title: "Logout",
          icon: LogOut,
          type: "logout",
          active: false,
          // path: `/app/project/project-settings`,
          inner: false,
          outer: true,
        },
      ],
    },
  ];
  const { t } = useTranslation();
  const { setMainMenu, sidebartoogle, setNavActive } = props;
  const [mainMenu, setMenu] = useState([]);
  console.log(props, "props");
  const history = useNavigate();
  const Logout = () => {
    logger.log(LogEvents.logOut, {});
    localStorage.removeItem("profileURL");
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("auth0_profile");
    localStorage.removeItem("Name");
    localStorage.removeItem("currentUser");
    localStorage.setItem("authenticated", false);
    history(`/login`);
  };
  useEffect(() => {
    const {
      settings: { project, projectSelected },
    } = props;
    var menuFinal = [];

    if (props.settings?.organisation?.lead_field) {
      MENUITEMS_LEADID.map((each) => {
        var outerMenu = {
          menutitle: each.menutitle,
          Items: [],
        };
        var innerMenu = [];
        for (var i = 0; i < each.Items.length; i++) {
          var item = each.Items[i];
          if (item.outer && item.inner) {
            innerMenu.push(item);
          } else if (!item.outer && item.inner) {
            if (props?.settings.projectSelected) {
              innerMenu.push(item);
            }
          } else if (item.outer && !item.inner) {
            if (!props?.settings.projectSelected) {
              innerMenu.push(item);
            }
          }
        }
        outerMenu.Items = innerMenu;
        menuFinal.push(outerMenu);
      });
    } else {
      MENUITEMS.map((each) => {
        var outerMenu = {
          menutitle: each.menutitle,
          Items: [],
        };
        var innerMenu = [];
        for (var i = 0; i < each.Items.length; i++) {
          var item = each.Items[i];
          if (item.outer && item.inner) {
            innerMenu.push(item);
          } else if (!item.outer && item.inner) {
            if (props?.settings.projectSelected) {
              innerMenu.push(item);
            }
          } else if (item.outer && !item.inner) {
            if (!props?.settings.projectSelected) {
              innerMenu.push(item);
            }
          }
        }
        outerMenu.Items = innerMenu;
        menuFinal.push(outerMenu);
      });
    }

    setMenu(menuFinal);
  }, [
    props.settings.project,
    props?.settings.projectSelected,
    props.settings?.organisation?.lead_field,
  ]);

  const toggletNavActive = (item) => {
    if (!item.active) {
      mainMenu.map((a) => {
        a.Items.filter((Items) => {
          if (a.Items.includes(item)) Items.active = false;
          if (!Items.children) return false;
          Items.children.forEach((b) => {
            if (Items.children.includes(item)) {
              b.active = false;
            }
            if (!b.children) return false;
            b.children.forEach((c) => {
              if (b.children.includes(item)) {
                c.active = false;
              }
            });
          });
          return Items;
        });
        return a;
      });
    }
    item.active = !item.active;
    setMainMenu({ mainmenu: mainMenu });
  };

  return (
    <Fragment>
      <UL attrUL={{ className: "nav-menu custom-scrollbar" }}>
        <LI attrLI={{ className: "back-btn" }}>
          <div className="mobile-back text-end">
            <span>Back</span>
            <i className="fa fa-angle-right ps-2"></i>
          </div>
        </LI>

        {mainMenu.map((Item, i) => (
          <Fragment key={i}>
            {/* <LI attrLI={{ className: 'sidebar-main-title' }} >
              <div>
                <H6>{t(Item.menutitle)}</H6>
              </div>
            </LI> */}
            {Item.Items.map((menuItem, i) => (
              <LI attrLI={{ className: "dropdown" }} key={i}>
                {menuItem.type === "sub" && (
                  <a
                    href="javascript"
                    id="nav-link"
                    className={`nav-link menu-title ${
                      menuItem.active ? "active" : ""
                    }`}
                    onClick={(event) => {
                      event.preventDefault();
                      setNavActive(menuItem);
                    }}
                  >
                    {menuItem.icon !== undefined && <menuItem.icon />}
                    <span>{t(menuItem.title)}</span>
                    <div className="according-menu">
                      {menuItem.active ? (
                        <i className="fa fa-angle-down"></i>
                      ) : (
                        <i className="fa fa-angle-right"></i>
                      )}
                    </div>
                  </a>
                )}
                {menuItem.type === "link" && (
                  <Link
                    to={menuItem.path}
                    id="nav-link"
                    className={`nav-link menu-title ${
                      menuItem.active ? "active" : ""
                    }`}
                    onClick={() => toggletNavActive(menuItem)}
                  >
                    {menuItem.icon !== undefined && menuItem.icon}

                    <span>{menuItem.title}</span>

                    {menuItem.badge && (
                      <Label className={menuItem.badge}>
                        {menuItem.badgetxt}
                      </Label>
                    )}
                  </Link>
                )}
                {menuItem.type === "logout" && (
                  <div
                    // to={menuItem.path}
                    id="nav-link"
                    className={`nav-link menu-title d-flex align-items-center ${
                      menuItem.active ? "active" : ""
                    }`}
                    style={{ cursor: "pointer" }}
                    onClick={() => Logout()}
                  >
                    {menuItem.icon !== undefined && <menuItem.icon size={18} />}

                    <span style={{ marginLeft: "10px" }}>
                      {t(menuItem.title)}
                    </span>

                    {menuItem.badge && (
                      <Label className={menuItem.badge}>
                        {menuItem.badgetxt}
                      </Label>
                    )}
                  </div>
                )}
                {menuItem.children && (
                  <UL
                    attrUL={{
                      className: "simple-list sidebar-submenu",
                    }}
                  >
                    <UL
                      attrUL={{
                        className: "nav-submenu menu-content",
                        style: menuItem.active
                          ? sidebartoogle
                            ? {
                                opacity: 1,
                                transition: "opacity 500ms ease-in",
                              }
                            : { display: "block" }
                          : { display: "none" },
                      }}
                    >
                      {menuItem.children.map((childrenItem, index) => {
                        return (
                          <LI key={index}>
                            {childrenItem.type === "sub" && (
                              <a
                                href="javascript"
                                className={`${
                                  childrenItem.active ? "active" : ""
                                }`}
                                onClick={(event) => {
                                  event.preventDefault();
                                  toggletNavActive(childrenItem);
                                }}
                              >
                                {t(childrenItem.title)}
                                <div className="according-menu">
                                  {childrenItem.active ? (
                                    <i className="fa fa-caret-down"></i>
                                  ) : (
                                    <i className="fa fa-caret-right"></i>
                                  )}{" "}
                                </div>
                              </a>
                            )}
                            {childrenItem.type === "link" && (
                              <Link
                                to={childrenItem.path}
                                className={`${
                                  childrenItem.active ? "active" : ""
                                }`}
                                onClick={() => toggletNavActive(childrenItem)}
                              >
                                {t(childrenItem.title)}
                              </Link>
                            )}
                            {childrenItem.children && (
                              <UL
                                attrUL={{
                                  className:
                                    "simple-list nav-sub-childmenu submenu-content",
                                  style: childrenItem.active
                                    ? { display: "block" }
                                    : { display: "none" },
                                }}
                              >
                                {childrenItem.children.map(
                                  (childrenSubItem, key) => (
                                    <LI key={key}>
                                      {childrenSubItem.type === "link" && (
                                        <Link
                                          to={childrenSubItem.path}
                                          className={`${
                                            childrenSubItem.active
                                              ? "active"
                                              : ""
                                          }`}
                                          onClick={() =>
                                            toggletNavActive(childrenSubItem)
                                          }
                                        >
                                          {t(childrenSubItem.title)}
                                        </Link>
                                      )}
                                    </LI>
                                  )
                                )}
                              </UL>
                            )}
                          </LI>
                        );
                      })}
                    </UL>
                  </UL>
                )}
              </LI>
            ))}
          </Fragment>
        ))}
      </UL>
    </Fragment>
  );
};
export default connect(mapStateToProps)(SidebarMenuItems);
